import { inject, Injectable, signal } from '@angular/core';
import { SignalRService } from './signalr.service';
import type { ActiveRecordingStatusDTO } from '../features/session/model/active-recording-status.dto';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { devError, devLog } from '../shared/dev-log';

@Injectable({ providedIn: 'root' })
export class SessionRecordingStateService {
  private readonly signalRService = inject(SignalRService);
  // eslint-disable-next-line @typescript-eslint/naming-convention
  private readonly _activeRecordings = signal<ActiveRecordingStatusDTO[]>([]);

  readonly activeRecordings = this._activeRecordings.asReadonly();

  constructor() {
    this.signalRService
      .listen('ActiveRecordingStatusUpdate')
      .pipe(takeUntilDestroyed())
      .subscribe({
        next: response => {
          this._activeRecordings.set(response.data ?? []);
          devLog('Received ActiveRecordingStatusUpdate:', response.data);
        },
        error: err => {
          devError('Error receiving ActiveRecordingStatusUpdate:', err);
        },
      });
  }
}
